import { ArrowRightOutlined } from '@ant-design/icons';

interface TrialCtaButtonProps {
  variant?: 'full' | 'compact' | 'link';
  source?: string;
}

export function TrialCtaButton({ variant = 'full', source = 'sidebar' }: TrialCtaButtonProps) {
  const href = `https://raporgor.com/kayit?utm_source=demo&utm_medium=${encodeURIComponent(source)}`;

  if (variant === 'link') {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        Deneme başlat <ArrowRightOutlined style={{ fontSize: 11 }} />
      </a>
    );
  }

  const isCompact = variant === 'compact';
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        ...btnStyle,
        padding: isCompact ? '5px 12px' : '9px 16px',
        fontSize: isCompact ? 12 : 13,
        width: isCompact ? 'auto' : '100%',
      }}
    >
      Deneme başlat
      <ArrowRightOutlined style={{ fontSize: 11 }} />
    </a>
  );
}

const btnStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  background: 'var(--color-primary)',
  color: '#ffffff',
  fontWeight: 500,
  letterSpacing: 0.1,
  textDecoration: 'none',
  border: '1px solid var(--color-primary)',
  borderRadius: 4,
  transition: 'background .12s ease, border-color .12s ease',
  whiteSpace: 'nowrap',
};

const linkStyle: React.CSSProperties = {
  color: '#ffffff',
  fontWeight: 600,
  fontSize: 12,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  opacity: 0.95,
};
